export default __webpack_public_path__ + "static/media/chair.1bb2ee89.jpg";